<template>
<v-container fluid >
    <h1 class="d-flex justify-center textTitle--text font-weight-black">{{ $t('views.compras.screenTitle') }}</h1>
    <v-card elevation="11" class="ma-3 pa-3 primary">
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        :label="$t('search')"
        single-line
        class="tertiary font-weight-black mx-8"
        hide-details
        outlined
      ></v-text-field>
    
    <v-data-table
    :headers="headers"
    :items="compras"
    class="elevation-5 tertiary pa-3 ma-5 textTable--text font-weight-black text-h3 text-center"
    :search="search"
    
  >
  <template v-slot:[`item.date`]="{ item }">
    
           <span>{{new Date(item.date) | dateFormat('DD MMMM YYYY')}}</span>
         </template>
    
    
    <template v-slot:[`item.actions`]="{ item }">
      
      <v-icon
        @click="deleteProduct(item)"
        color="error darken-3"
      >mdi-delete</v-icon>
      <v-dialog v-model="dialogDelete" max-width="80%" :retain-focus="false">
        
          <v-card class="pa-5 secondary">
          <v-card class="pa-5 primary" elevation="11">
            <v-card-text class="text-h6 font-weight-black textTitle--text">{{ $t('views.compras.confirmDeleteMessage') }}</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="error font-weight-black black--text" elevation="8" @click="dialogDelete = false">{{ $t('cancel') }}</v-btn>
              <v-btn color="success font-weight-black black--text" elevation="8" @click="deleteItemConfirm">OK</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
          </v-card>
        </v-dialog>
    </template>
    
    
  </v-data-table>
      
    </v-card>
    
    
</v-container>
</template>

<script>
          
export default {
    data () {
        return {
            search:"",
            dialogDelete:false,
            dialogModif:false,
            returnprod:0,

            
            buyactive:{},

        }

    },
    computed:{
      headers(){
        var headers= [
              { text: this.$t('headers.actions'), value: 'actions', sortable: false,class: 'text-center quaterny primary--text font-weight-black text-subtitle-2' },
              {
                text: this.$t('date'),
                align: 'start',
                value: 'date',
                class: 'quaterny primary--text font-weight-black text-subtitle-2 text-center'
              },
              {
                text: this.$t('headers.prodName'),
                align: 'start',
                value: 'prodname',
                class: 'quaterny primary--text font-weight-black text-subtitle-2 text-center'
              },
              { text: this.$t('headers.unitPrice'), value: 'pu',class: 'text-center quaterny primary--text font-weight-black text-subtitle-2'},
              { text: this.$t('qty'), value: 'qty',class: 'text-center quaterny primary--text font-weight-black text-subtitle-2'},
              { text: this.$t('headers.supplier'), value: 'vendedor',class: 'text-center quaterny primary--text font-weight-black text-subtitle-2'},
              { text: this.$t('total'), value: 'total',class: 'text-center quaterny primary--text font-weight-black text-subtitle-2'},
              
            ]
            return headers
      },
      compras(){
        return this.$store.state.bills
      }
    },
    
    methods:{
      
        deleteItemConfirm () {
             this.$store.dispatch('deleteBill',this.buyactive)
             
         this.dialogDelete = false
      },
      
      editItem (item) {
        this.saleactive=item
        this.dialogModif=true
      },
      deleteProduct(item){
        this.dialogDelete = true
        this.buyactive=item
      },
      

    }
}
</script>